// extracted by mini-css-extract-plugin
export default {"wrap":"mF-z","fullWidth":"nF-z","hideOnDesktop":"oF-z","content":"pF-z","hasOpenedNav":"qF-z","crumbsList":"rF-z","dropdownsWrap":"sF-z"};